<!-- IHUB redesign bottom tab bar -->
<nav class="ihx-tabbar">
  <button
    *ngFor="let tab of tabs"
    type="button"
    class="tab"
    [class.center]="tab.center"
    [class.active]="activeId === tab.id"
    (click)="go(tab)">
    <div *ngIf="tab.center" class="tab-fab"><lucide-icon [name]="tab.icon | faToLucide" class="lc"></lucide-icon></div>
    <lucide-icon *ngIf="!tab.center" [name]="tab.icon | faToLucide" class="lc"></lucide-icon>
    <span>{{ tab.label | translate }}</span>
  </button>
</nav>
